/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * AX Studio Server
 * API Server for AX Studio
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppCommonUsersRouterMeResponse,
  AvatarUpdateRequest,
  AvatarUpdateResponse,
  GetExecutionHistoryApiUsersExecutionsGetParams,
  HTTPValidationError
} from '../api.schemas';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * 사용자의 아바타 URL 수정
 * @summary 아바타 URL 수정
 */
export const updateAvatarApiUsersMeAvatarPost = (
    avatarUpdateRequest: AvatarUpdateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AvatarUpdateResponse>(
      {url: `/api/users/me/avatar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: avatarUpdateRequest, signal
    },
      options);
    }
  


export const getUpdateAvatarApiUsersMeAvatarPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAvatarApiUsersMeAvatarPost>>, TError,{data: AvatarUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAvatarApiUsersMeAvatarPost>>, TError,{data: AvatarUpdateRequest}, TContext> => {

const mutationKey = ['updateAvatarApiUsersMeAvatarPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAvatarApiUsersMeAvatarPost>>, {data: AvatarUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateAvatarApiUsersMeAvatarPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAvatarApiUsersMeAvatarPostMutationResult = NonNullable<Awaited<ReturnType<typeof updateAvatarApiUsersMeAvatarPost>>>
    export type UpdateAvatarApiUsersMeAvatarPostMutationBody = AvatarUpdateRequest
    export type UpdateAvatarApiUsersMeAvatarPostMutationError = HTTPValidationError

    /**
 * @summary 아바타 URL 수정
 */
export const useUpdateAvatarApiUsersMeAvatarPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAvatarApiUsersMeAvatarPost>>, TError,{data: AvatarUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAvatarApiUsersMeAvatarPost>>,
        TError,
        {data: AvatarUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateAvatarApiUsersMeAvatarPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * 현재 로그인된 사용자 정보 (비로그인 시 authenticated=false)
 * @summary 내 정보 조회
 */
export const getMeApiUsersMeGet = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppCommonUsersRouterMeResponse>(
      {url: `/api/users/me`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMeApiUsersMeGetQueryKey = () => {
    return [
    `/api/users/me`
    ] as const;
    }

    
export const getGetMeApiUsersMeGetQueryOptions = <TData = Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeApiUsersMeGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeApiUsersMeGet>>> = ({ signal }) => getMeApiUsersMeGet(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeApiUsersMeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMeApiUsersMeGet>>>
export type GetMeApiUsersMeGetQueryError = unknown


export function useGetMeApiUsersMeGet<TData = Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeApiUsersMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMeApiUsersMeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeApiUsersMeGet<TData = Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeApiUsersMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMeApiUsersMeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeApiUsersMeGet<TData = Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 내 정보 조회
 */

export function useGetMeApiUsersMeGet<TData = Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiUsersMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeApiUsersMeGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 사용자의 북마크한 에이전트 목록 조회
 * @summary 북마크 목록 조회
 */
export const getUserBookmarksApiUsersBookmarksGet = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/users/bookmarks`, method: 'GET', signal
    },
      options);
    }
  



export const getGetUserBookmarksApiUsersBookmarksGetQueryKey = () => {
    return [
    `/api/users/bookmarks`
    ] as const;
    }

    
export const getGetUserBookmarksApiUsersBookmarksGetQueryOptions = <TData = Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBookmarksApiUsersBookmarksGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>> = ({ signal }) => getUserBookmarksApiUsersBookmarksGet(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserBookmarksApiUsersBookmarksGetQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>>
export type GetUserBookmarksApiUsersBookmarksGetQueryError = unknown


export function useGetUserBookmarksApiUsersBookmarksGet<TData = Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>,
          TError,
          Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBookmarksApiUsersBookmarksGet<TData = Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>,
          TError,
          Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBookmarksApiUsersBookmarksGet<TData = Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 북마크 목록 조회
 */

export function useGetUserBookmarksApiUsersBookmarksGet<TData = Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookmarksApiUsersBookmarksGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserBookmarksApiUsersBookmarksGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 에이전트 북마크 상태 확인
 * @summary 북마크 상태 확인
 */
export const getBookmarkStatusApiUsersBookmarksAgentIdStatusGet = (
    agentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/users/bookmarks/${agentId}/status`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBookmarkStatusApiUsersBookmarksAgentIdStatusGetQueryKey = (agentId?: string,) => {
    return [
    `/api/users/bookmarks/${agentId}/status`
    ] as const;
    }

    
export const getGetBookmarkStatusApiUsersBookmarksAgentIdStatusGetQueryOptions = <TData = Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError = HTTPValidationError>(agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookmarkStatusApiUsersBookmarksAgentIdStatusGetQueryKey(agentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>> = ({ signal }) => getBookmarkStatusApiUsersBookmarksAgentIdStatusGet(agentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(agentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookmarkStatusApiUsersBookmarksAgentIdStatusGetQueryResult = NonNullable<Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>>
export type GetBookmarkStatusApiUsersBookmarksAgentIdStatusGetQueryError = HTTPValidationError


export function useGetBookmarkStatusApiUsersBookmarksAgentIdStatusGet<TData = Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError = HTTPValidationError>(
 agentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>,
          TError,
          Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookmarkStatusApiUsersBookmarksAgentIdStatusGet<TData = Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError = HTTPValidationError>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>,
          TError,
          Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookmarkStatusApiUsersBookmarksAgentIdStatusGet<TData = Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError = HTTPValidationError>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 북마크 상태 확인
 */

export function useGetBookmarkStatusApiUsersBookmarksAgentIdStatusGet<TData = Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError = HTTPValidationError>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatusApiUsersBookmarksAgentIdStatusGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookmarkStatusApiUsersBookmarksAgentIdStatusGetQueryOptions(agentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 에이전트 북마크 추가
 * @summary 북마크 추가
 */
export const addBookmarkApiUsersBookmarksAgentIdPost = (
    agentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/users/bookmarks/${agentId}`, method: 'POST', signal
    },
      options);
    }
  


export const getAddBookmarkApiUsersBookmarksAgentIdPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addBookmarkApiUsersBookmarksAgentIdPost>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addBookmarkApiUsersBookmarksAgentIdPost>>, TError,{agentId: string}, TContext> => {

const mutationKey = ['addBookmarkApiUsersBookmarksAgentIdPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addBookmarkApiUsersBookmarksAgentIdPost>>, {agentId: string}> = (props) => {
          const {agentId} = props ?? {};

          return  addBookmarkApiUsersBookmarksAgentIdPost(agentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddBookmarkApiUsersBookmarksAgentIdPostMutationResult = NonNullable<Awaited<ReturnType<typeof addBookmarkApiUsersBookmarksAgentIdPost>>>
    
    export type AddBookmarkApiUsersBookmarksAgentIdPostMutationError = HTTPValidationError

    /**
 * @summary 북마크 추가
 */
export const useAddBookmarkApiUsersBookmarksAgentIdPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addBookmarkApiUsersBookmarksAgentIdPost>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addBookmarkApiUsersBookmarksAgentIdPost>>,
        TError,
        {agentId: string},
        TContext
      > => {

      const mutationOptions = getAddBookmarkApiUsersBookmarksAgentIdPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * 에이전트 북마크 삭제
 * @summary 북마크 삭제
 */
export const removeBookmarkApiUsersBookmarksAgentIdDelete = (
    agentId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<unknown>(
      {url: `/api/users/bookmarks/${agentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemoveBookmarkApiUsersBookmarksAgentIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeBookmarkApiUsersBookmarksAgentIdDelete>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeBookmarkApiUsersBookmarksAgentIdDelete>>, TError,{agentId: string}, TContext> => {

const mutationKey = ['removeBookmarkApiUsersBookmarksAgentIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeBookmarkApiUsersBookmarksAgentIdDelete>>, {agentId: string}> = (props) => {
          const {agentId} = props ?? {};

          return  removeBookmarkApiUsersBookmarksAgentIdDelete(agentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveBookmarkApiUsersBookmarksAgentIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof removeBookmarkApiUsersBookmarksAgentIdDelete>>>
    
    export type RemoveBookmarkApiUsersBookmarksAgentIdDeleteMutationError = HTTPValidationError

    /**
 * @summary 북마크 삭제
 */
export const useRemoveBookmarkApiUsersBookmarksAgentIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeBookmarkApiUsersBookmarksAgentIdDelete>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeBookmarkApiUsersBookmarksAgentIdDelete>>,
        TError,
        {agentId: string},
        TContext
      > => {

      const mutationOptions = getRemoveBookmarkApiUsersBookmarksAgentIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * 에이전트 북마크 토글
 * @summary 북마크 토글
 */
export const toggleBookmarkApiUsersBookmarksAgentIdTogglePost = (
    agentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/users/bookmarks/${agentId}/toggle`, method: 'POST', signal
    },
      options);
    }
  


export const getToggleBookmarkApiUsersBookmarksAgentIdTogglePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleBookmarkApiUsersBookmarksAgentIdTogglePost>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleBookmarkApiUsersBookmarksAgentIdTogglePost>>, TError,{agentId: string}, TContext> => {

const mutationKey = ['toggleBookmarkApiUsersBookmarksAgentIdTogglePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleBookmarkApiUsersBookmarksAgentIdTogglePost>>, {agentId: string}> = (props) => {
          const {agentId} = props ?? {};

          return  toggleBookmarkApiUsersBookmarksAgentIdTogglePost(agentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleBookmarkApiUsersBookmarksAgentIdTogglePostMutationResult = NonNullable<Awaited<ReturnType<typeof toggleBookmarkApiUsersBookmarksAgentIdTogglePost>>>
    
    export type ToggleBookmarkApiUsersBookmarksAgentIdTogglePostMutationError = HTTPValidationError

    /**
 * @summary 북마크 토글
 */
export const useToggleBookmarkApiUsersBookmarksAgentIdTogglePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleBookmarkApiUsersBookmarksAgentIdTogglePost>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleBookmarkApiUsersBookmarksAgentIdTogglePost>>,
        TError,
        {agentId: string},
        TContext
      > => {

      const mutationOptions = getToggleBookmarkApiUsersBookmarksAgentIdTogglePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * 사용자의 에이전트 실행 기록 조회

- **skip**: 건너뛸 개수 (페이지네이션)
- **limit**: 조회할 개수 (기본값: 50)
- **agent_id**: 특정 에이전트의 기록만 필터링 (선택)
 * @summary 실행 기록 조회
 */
export const getExecutionHistoryApiUsersExecutionsGet = (
    params?: GetExecutionHistoryApiUsersExecutionsGetParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/users/executions`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetExecutionHistoryApiUsersExecutionsGetQueryKey = (params?: GetExecutionHistoryApiUsersExecutionsGetParams,) => {
    return [
    `/api/users/executions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetExecutionHistoryApiUsersExecutionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError = HTTPValidationError>(params?: GetExecutionHistoryApiUsersExecutionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExecutionHistoryApiUsersExecutionsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>> = ({ signal }) => getExecutionHistoryApiUsersExecutionsGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExecutionHistoryApiUsersExecutionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>>
export type GetExecutionHistoryApiUsersExecutionsGetQueryError = HTTPValidationError


export function useGetExecutionHistoryApiUsersExecutionsGet<TData = Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetExecutionHistoryApiUsersExecutionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>,
          TError,
          Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutionHistoryApiUsersExecutionsGet<TData = Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError = HTTPValidationError>(
 params?: GetExecutionHistoryApiUsersExecutionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>,
          TError,
          Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutionHistoryApiUsersExecutionsGet<TData = Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError = HTTPValidationError>(
 params?: GetExecutionHistoryApiUsersExecutionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 실행 기록 조회
 */

export function useGetExecutionHistoryApiUsersExecutionsGet<TData = Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError = HTTPValidationError>(
 params?: GetExecutionHistoryApiUsersExecutionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutionHistoryApiUsersExecutionsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExecutionHistoryApiUsersExecutionsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




